const set = (key = '', values) => localStorage.setItem(key, values)
const get = (key = '') => localStorage.getItem(key) || null
const forget = (key = '') => localStorage.removeItem(key)
const clear = () => localStorage.clear()
const parseToJson = (key = '') => {
    if (get(key)) {
        try {
            const object = JSON.parse(get(key));
            if (typeof object === 'object' && object !== null) {
                return object
            } else {
                throw new Error(`El valor en localStorage con clave "${key}" no es un objeto.`)
            }
        } catch (error) {
            throw new Error(`Error al analizar el valor en localStorage con clave "${key}": ${error}`)
        }
    } else {
        throw new Error(`No se encontró ningún valor en localStorage con clave "${key}".`)
    }
}

export {
    set
    , get
    , parseToJson
    , forget
    , clear
}